import { Col, SelectField } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { shouldShowIndicatorDataNatureType } from '@/features/search/_utils/activity-indicator-conditions';
import {
  IndicatorDataNatureTypeModifier,
  indicatorDataNatureTypeEnum,
} from '@/features/search/_utils/enum';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const ActivityIndicatorDataNatureTypeColField: FC = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext<ProjectSearchFormType>();

  const [indicatorType, hasOnlyQualitativeIndicator] = watch([
    'indicatorType',
    'hasOnlyQualitativeIndicator',
  ]);

  const result = shouldShowIndicatorDataNatureType(
    indicatorType,
    hasOnlyQualitativeIndicator,
  );

  if (result.result === 'unNeed') {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="indicatorDataNatureType"
        label={t('type')}
        control={control}
        errors={errors}
        options={indicatorDataNatureTypeEnum.options.map((value) => ({
          value,
          label: IndicatorDataNatureTypeModifier[value],
        }))}
        disabled={result.result === 'disable'}
      />
    </Col>
  );
};
